import React from 'react';
import { Phone, Star } from 'lucide-react';
import { EstimateForm } from '../../components/EstimateForm/EstimateForm';
export function HeroQuotePanel() {
  return <div id="estimate-form" className="lg:col-span-5 w-full max-w-md mx-auto lg:mx-0 lg:ml-auto anim-fade-scale" style={{
    animationDelay: '0.1s'
  }} data-id="element-125">
      <div className="bg-white rounded-2xl shadow-card border border-slate-100 overflow-hidden" data-id="element-126">
        <div className="bg-brandBlue-600 px-6 py-4 text-center" data-id="element-127">
          <span className="inline-block bg-brandBlue-700 text-white text-xs font-bold uppercase tracking-wider py-1 px-2 rounded mb-2" data-id="element-128">
            Free In-Home Estimate
          </span>
          <h2 className="text-2xl font-bold text-white" data-id="element-129">
            Request a Residential Glass Quote
          </h2>
        </div>

        <div className="p-6 sm:p-8" data-id="element-130">
          <p className="text-sm text-slate-600 mb-6 text-center" data-id="element-131">
            Submit your details and a Kosin’s Glass team member will contact you
            to confirm your project, location, glass dimensions, photos and
            appointment availability.
          </p>

          <EstimateForm data-id="element-132" />

          <div className="mt-6 text-center" data-id="element-133">
            <a href="tel:5175457772" className="inline-flex items-center justify-center gap-2 text-navy-900 font-medium hover:text-brandBlue-600 transition-colors" data-id="element-134">
              <Phone className="w-4 h-4" aria-hidden="true" data-id="element-135" />
              Prefer to call? Howell Service Center: 517-545-7772
            </a>
          </div>

          <p className="text-xs text-slate-400 text-center mt-4" data-id="element-136">
            We respect your privacy. Your details are safe with us.
          </p>

          <figure className="mt-5 pt-5 border-t border-slate-100" data-id="element-137">
            <div className="flex items-center gap-1 text-amber-500 mb-2" aria-label="5-star review" data-id="element-138">
              <Star className="w-3.5 h-3.5 fill-amber-500" data-id="element-139" />
              <Star className="w-3.5 h-3.5 fill-amber-500" data-id="element-140" />
              <Star className="w-3.5 h-3.5 fill-amber-500" data-id="element-141" />
              <Star className="w-3.5 h-3.5 fill-amber-500" data-id="element-142" />
              <Star className="w-3.5 h-3.5 fill-amber-500" data-id="element-143" />
            </div>
            <blockquote className="text-sm italic text-slate-600 leading-relaxed" data-id="element-144">
              “[Paste short real customer review here.]”
            </blockquote>
            <figcaption className="text-xs text-slate-500 mt-2 not-italic" data-id="element-145">
              — [Customer Name], [City]
            </figcaption>
          </figure>
        </div>
      </div>
    </div>;
}